import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'suggest' })
export class InteropSuggestPipe implements PipeTransform {
    transform(value): any {
          if(!value) return null;
          var arr=Object.keys(value);
          return Object.keys(value);
    }
}